import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { format } from 'date-fns';
import { AttendanceSheetResponseDto } from '@/api.types';
import { SignatureRoleEnum } from '../../enums/signature-role.enum';

interface IMyProps {
  show: boolean;
  folha: AttendanceSheetResponseDto | null;
  handleHide: (
    e:
      | React.FormEvent<HTMLFormElement>
      | React.MouseEvent<HTMLButtonElement>
      | HTMLElement,
  ) => void;
}

const getPerfilAssinanteLabel = (perfil: number): string => {
  switch (perfil) {
    case SignatureRoleEnum.ESTAGIARIO:
      return 'Estagiário';
    case SignatureRoleEnum.RESPONSAVEL:
      return 'Responsável';
    case SignatureRoleEnum.SETOR_ESTAGIO:
      return 'Setor de Estágio';
    default:
      return 'Desconhecido';
  }
};

export default function ModalAssinaturas({ show, folha, handleHide }: IMyProps) {
  // Ordenar assinaturas por data (mais antigas primeiro)
  const assinaturasOrdenadas = folha?.assinaturas
    ? [...folha.assinaturas].sort((a, b) =>
      new Date(a.criadoEm).getTime() - new Date(b.criadoEm).getTime()
    )
    : [];

  // Verificar se há assinaturas que não sejam de estagiário (para mostrar coluna de status)
  const temAssinaturasNaoEstagiario = assinaturasOrdenadas.some(
    (a) => a.perfilAssinante !== SignatureRoleEnum.ESTAGIARIO
  );

  return (
    <Modal
      show={show}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      onExit={handleHide}
      centered
    >
      <Modal.Header closeButton={false}>
        <Modal.Title id="contained-modal-title-vcenter">
          Assinaturas da Folha de Frequência
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {folha && assinaturasOrdenadas.length > 0 ? (
          <div className="table-responsive">
            <table className="table table-sm table-striped table-hover">
              <thead>
                <tr>
                  <th>Data/Hora</th>
                  <th>Perfil</th>
                  {temAssinaturasNaoEstagiario && <th>Status</th>}
                  {/* <th>IP</th> */}
                  <th>Justificativa</th>
                </tr>
              </thead>
              <tbody className="table-group-divider">
                {assinaturasOrdenadas.map((assinatura, index) => (
                  <tr key={index}>
                    <td>{format(new Date(assinatura.criadoEm), 'dd/MM/yyyy HH:mm')}</td>
                    <td>{getPerfilAssinanteLabel(assinatura.perfilAssinante)}</td>
                    {temAssinaturasNaoEstagiario && (
                      <td className="">
                        {assinatura.perfilAssinante !== SignatureRoleEnum.ESTAGIARIO ? (
                          assinatura.aprovacao ? (
                            <span className="badge bg-success">Aprovado</span>
                          ) : (
                            <span className="badge bg-danger">Rejeitado</span>
                          )
                        ) : (
                          <span className="text-muted">-</span>
                        )}
                      </td>
                    )}
                    {/* <td>{assinatura.ip}</td> */}
                    <td>
                      {assinatura.justificativa ? (
                        <span className="text-break">{assinatura.justificativa}</span>
                      ) : (
                        <span className="text-muted fst-italic">Sem justificativa</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p className="text-muted">Nenhuma assinatura encontrada para esta folha.</p>
        )}
      </Modal.Body>
      <Modal.Footer className="text-left">
        <Button variant="secondary" onClick={handleHide}>
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
